import type { Object3D, Vector3 } from 'three';

/**
 * Get world position of an object
 */
export const getWorldPosition = (object: Object3D): { x: number; y: number; z: number } => {
	// Ensure world matrix is up to date
	object.updateWorldMatrix(true, false);
	const pos = object.position.clone();

	// If object has parent, get actual world position
	if (object.parent) {
		object.getWorldPosition(pos as Vector3);
	}

	return { x: pos.x, y: pos.y, z: pos.z };
};

/**
 * Get world rotation of an object
 */
export const getWorldRotation = (object: Object3D): { x: number; y: number; z: number } => {
	return {
		x: object.rotation.x,
		y: object.rotation.y,
		z: object.rotation.z
	};
};

/**
 * Check if position has changed beyond tolerance
 */
export const hasPositionChanged = (
	oldPos: { x: number; y: number; z: number },
	newPos: { x: number; y: number; z: number },
	tolerance: number
): boolean => {
	const dx = Math.abs(oldPos.x - newPos.x);
	const dy = Math.abs(oldPos.y - newPos.y);
	const dz = Math.abs(oldPos.z - newPos.z);

	return dx > tolerance || dy > tolerance || dz > tolerance;
};
